// extracted by mini-css-extract-plugin
module.exports =  {"loader":"coursesFunction__loader","course-container":"coursesFunction__course-container"};